import React, {FC} from 'react';

import {ButtonGroup} from '../../../../../libs/shared/ui/src/components/buttons/buttonGroup/buttonGroup';
import {
  getSortedWeekdays,
  weekdayNumberToCalendarWeekdayMap,
} from '../../../../../srcCommon/helpers/calendarHelpers';
import {CalendarWeekDaysEnum} from '../../../../models/api/calendarCommonTypes';
import {RecurrenceWeekdayModel} from '../../../../models/api/recurrenceModel';
import {RecurrenceWeekdayButton} from './recurrenceWeekdayButton';

/*
 * Props.
 */

export interface RecurrenceWeeklyWeekdayEditorProps {
  weekStart: CalendarWeekDaysEnum;
  recurrenceWeekdays: ReadonlyArray<RecurrenceWeekdayModel> | undefined;
  setRecurrenceWeekdays: (arg: Array<RecurrenceWeekdayModel> | undefined) => void;
}

/*
 * Component.
 */

export const RecurrenceWeeklyWeekdayEditor: FC<RecurrenceWeeklyWeekdayEditorProps> = (props) => {
  const {weekStart, recurrenceWeekdays, setRecurrenceWeekdays} = props;

  const weekdays = getSortedWeekdays(weekStart);
  return (
    <ButtonGroup>
      {weekdays.map((weekday) =>
        renderWeekdayButton(weekday, recurrenceWeekdays || [], setRecurrenceWeekdays),
      )}
    </ButtonGroup>
  );
};

function renderWeekdayButton(
  weekdayNumber: number,
  recurrenceWeekdays: ReadonlyArray<RecurrenceWeekdayModel>,
  setRecurrenceWeekdays: (arg: Array<RecurrenceWeekdayModel> | undefined) => void,
) {
  const weekdayName = weekdayNumberToCalendarWeekdayMap[weekdayNumber];
  const selectedWeekdays = recurrenceWeekdays.map((w) => w.weekday);
  const isSelected = selectedWeekdays.includes(weekdayName);
  const onClick = () => {
    // If this weekday was selected, remove it the list of weekdays.
    // If it wasn't selected, add it.
    const newlySelectedWeekdays = isSelected
      ? recurrenceWeekdays.filter((w) => w.weekday !== weekdayName)
      : [...recurrenceWeekdays, {weekday: weekdayName, n: undefined}];

    return setRecurrenceWeekdays(newlySelectedWeekdays);
  };
  return (
    <RecurrenceWeekdayButton
      key={weekdayNumber}
      weekdayNumber={weekdayNumber}
      isSelected={isSelected}
      onClick={onClick}
    />
  );
}
